export default {
    navigationBarTitleText: intl.get('commonPage.previewPDFTitle')
}
